import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Login from './components/login';
import AdminPage from './components/admin';
import CargaPage from './components/carga';
// Keeping old imports commented for reference
// import PickerPage from './components/picker';
// import FrioPage from './components/frio';
import PickerV2Page from './components/pickerv2';
import CartPickerPage from './components/cartPickerPage';
import ProtectedRoute from './components/ProtectedRoute';
import { useAuth } from './context/AuthContext';
import QrScanner from './components/QrScanner';
import QrScanner2 from './components/QrScanner2';
import Barcode from './components/BarCode';
import AgregarProducto from './components/AgregarProducto';
import AdminCart from './components/admincart';
import QrScanner3Component from './components/QrScanner3';
import AdminProductos from './components/adminproductos';
import Check from './components/check';
import Carrito from './components/carrito';
import Productos from './components/productos';
import Completarpedido from './components/completarpedido';
import Informacion from './components/informacion';
import Screen from './components/screen';
import Storage from './components/storage';
import IngresoPage from './components/ingreso';
import Datos from './components/datos';
import MovimientoPage from './components/movimiento';
import Movimiento2Page from './components/movimiento2';
import Movimiento3Page from './components/movimiento3';
import MovimientoFinalPage from './components/movimientofinal';
import ErrorBarcode from './components/errorbarcode';
import BarcodeScannerComponent from './components/BarcodeScanner';
import AdminCodePage from './components/admincode';
import Init from './components/init';
import LoadSku from './components/loadsku';
import CartCode from './components/cartcode';
import InfoSku from './components/infosku';
import InfoSku2 from './components/infosku2';
import CancelOrderPage from './components/sales';
import DevolucionCarro from './components/DevolucionCarro';
import ProduccionHome from './components/ProduccionHome';
import ProduccionNueva from './components/ProduccionNueva';
import ProduccionRetiro from './components/ProduccionRetiro';
import ProduccionTerminar from './components/ProduccionTerminar';
import ProduccionCerrar from './components/ProduccionCerrar';
import ProduccionDetalle from './components/ProduccionDetalle';
import CartFreeScanner from './components/CartFreeScanner';
import SearchPO from './components/SearchPO';
import Solicitudes from './components/Solicitudes';
import VIPPreview from './components/VIPPreview';
import VaciarPicking from './components/VaciarPicking';
import RecepcionStock from './components/RecepcionStock';
import Contenedor from './components/Contenedor';
import MovimientoRecepcion from './components/MovimientoRecepcion';
import TestScanner from './components/TestScanner';
import Usuarios from './components/Usuarios';
import EditarStock from './components/editarStock';

const App = () => {
  const { isAuthenticated, userRole } = useAuth();

  return (
    <Router>
      <Routes>
        <Route path="/barcode" element={<BarcodeScannerComponent />} />
        <Route path="/" element={<Login />} />
        <Route
          path="/init"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              userRole={userRole}
              requiredRole={['admin', 'scanner']}
              element={<Init />}
            />
          }
        />
                <Route
          path="/admin"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              userRole={userRole}
              requiredRole={['admin', 'checker']}
              element={<AdminPage />}
            />
          }
        />
        <Route
          path="/carga"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              userRole={userRole}
              requiredRole="admin"
              element={<CargaPage />}
            />
          }
        />
                        <Route
          path="/sales"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              userRole={userRole}
              requiredRole="sales"
              element={<CancelOrderPage />}
            />
          }
        />
        <Route
          path="/admin/load_sku"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              userRole={userRole}
              requiredRole="admin"
              element={<LoadSku />}
            />
          }
        />
                <Route
          path="/admin/info_sku"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              userRole={userRole}
              requiredRole="admin"
              element={<InfoSku />}
            />
          }
        />
          <Route
          path="/admin/info_sku2"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              userRole={userRole}
              requiredRole="admin"
              element={<InfoSku2 />}
            />
          }
        />
        <Route
          path="/screen"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              userRole={userRole}
              requiredRole={['admin', 'checker']}
              element={<Screen />}
            />
          }
        />
        <Route
          path="/vip-preview"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              userRole={userRole}
              requiredRole="admin"
              element={<VIPPreview />}
            />
          }
        />
        <Route
          path="/picking"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              userRole={userRole}
              requiredRole={['picker', 'frozen']}
              element={<PickerV2Page />}
            />
          }
        />
        <Route
          path="/cartcode"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              userRole={userRole}
              requiredRole={userRole === 'picker' || userRole === 'frozen' || userRole === 'admin' ? userRole : null}
              element={<CartCode />}
            />
          }
        />
        <Route
          path="/devolucion/:cart_code"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              userRole={userRole}
              requiredRole={['picker', 'frozen', 'admin']}
              element={<DevolucionCarro />}
            />
          }
        />
        <Route
          path="/storage"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              userRole={userRole}
              requiredRole={userRole === 'storage' || userRole === 'admin' ? userRole : null}
              element={<Storage />}
            />
          }
        />
        <Route
          path="/storage/ingreso"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              userRole={userRole}
              requiredRole={userRole === 'storage' || userRole === 'admin' ? userRole : null}
              element={<IngresoPage />}
            />
          }
        />
        <Route
          path="/storage/ingreso/:scanCode"  // Definir la ruta con el parámetro :scanCode
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              userRole={userRole}
              requiredRole={userRole === 'storage' || userRole === 'admin' ? userRole : null}
              element={<Datos />}  // La página donde se mostrarán los datos
            />
          }
        />
        <Route
          path="/storage/movimiento-recepcion"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              userRole={userRole}
              requiredRole={userRole === 'storage' || userRole === 'admin' ? userRole : null}
              element={<MovimientoRecepcion />}
            />
          }
        />
        <Route
          path="/storage/movimiento"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              userRole={userRole}
              requiredRole={userRole === 'storage' || userRole === 'admin' ? userRole : null}
              element={<MovimientoPage />}
            />
          }
        />
        <Route
          path="/storage/movimiento/:scanCode/"  // Definir la ruta con el parámetro :scanCode
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              userRole={userRole}
              requiredRole={userRole === 'storage' || userRole === 'admin' ? userRole : null}
              element={<Movimiento2Page />}  // La página donde se mostrarán los datos
            />
          }
        />
        <Route
          path="/storage/movimiento/:scanCode/:scanCode2"  // Definir la ruta con el parámetro :scanCode
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              userRole={userRole}
              requiredRole={userRole === 'storage' || userRole === 'admin' ? userRole : null}
              element={<Movimiento3Page />}  // La página donde se mostrarán los datos
            />
          }
        />
                <Route
          path="/storage/movimiento/:scanCode/:scanCode2/:scanCode3"  // Definir la ruta con el parámetro :scanCode
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              userRole={userRole}
              requiredRole={userRole === 'storage' || userRole === 'admin' ? userRole : null}
              element={<MovimientoFinalPage />}  // La página donde se mostrarán los datos
            />
          }
        />
        {/* Ruta para escanear QR con número de PO */}
        <Route
          path="/qr-scanner/:po_number"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              userRole={userRole}
              requiredRole={userRole === 'picker' || userRole === 'frozen' ? userRole : null}
              element={<QrScanner />}
            />
          }
        />
        {/* Ruta para la página de selección de carrito con número de PO y código de carrito */}
        <Route
          path="/picker/:po_number/:cart_code"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              userRole={userRole}
              requiredRole={userRole === 'picker' || userRole === 'frozen' ? userRole : null}
              element={<CartPickerPage />}
            />
          }
        />
        {/* Ruta para el escáner QR con SKU */}
        <Route
          path="/picker/:po_number/:cart_code/:sku_code"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              userRole={userRole}
              requiredRole={userRole === 'picker' || userRole === 'frozen' ? userRole : null}
              element={<QrScanner2 />}
            />
          }
        />
                <Route
          path="/picker/:po_number/:cart_code/:sku_code/:formattedLocation/informacion"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              userRole={userRole}
              requiredRole={userRole === 'picker' || userRole === 'frozen' ? userRole : null}
              element={<Informacion />}
            />
          }
        />
        {/* Nueva ruta para Barcode con los parámetros especificados */}
        <Route
          path="/picker/:po_number/:cart_code/:sku_code/:rack-shelf"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              userRole={userRole}
              requiredRole={userRole === 'picker' || userRole === 'frozen' ? userRole : null}
              element={<Barcode />}
            />
          }
        />
        <Route
          path="/picker/:po_number/:cart_code/:sku_code/:rack-shelf/error"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              userRole={userRole}
              requiredRole={userRole === 'picker' || userRole === 'frozen' ? userRole : null}
              element={<ErrorBarcode />}
            />
          }
        />
        {/* Ruta para agregar producto */}
        <Route
          path="/picker/:po_number/:cart_code/:sku_code/:rack-shelf/:barcode"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              userRole={userRole}
              requiredRole={userRole === 'picker' || userRole === 'frozen' ? userRole : null}
              element={<AgregarProducto />}
            />
          }
        />
        <Route
          path="/admin/barcode" // Ruta para AdminCart
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              userRole={userRole}
              requiredRole="admin" // Solo el rol admin puede acceder
              element={<AdminCodePage />}
            />
          }
        />
        <Route
          path="/admin/:po_number" // Ruta para AdminCart
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              userRole={userRole}
              requiredRole={['admin', 'checker']}
              element={<AdminCart />}
            />
          }
        />
        {/* Nueva ruta para QrScanner3Component */}
        <Route
          path="/admin/:po_number/:cart" // Ruta para el escáner QR 3
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              userRole={userRole}
              requiredRole={['admin', 'checker']}
              element={<QrScanner3Component />}
            />
          }
        />
        {/* Ruta para AdminProductos */}
        <Route
          path="/admin/:po_number/:cart/productos"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              userRole={userRole}
              requiredRole={['admin', 'checker']}
              element={<AdminProductos />}
            />
          }
        />
        {/* Nueva ruta para Check */}
        <Route
          path="/admin/:po_number/:cart/productos/check"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              userRole={userRole}
              requiredRole={['admin', 'checker']}
              element={<Check />} // Componente Check
            />
          }
        />
        <Route
          path="/paid/:ponumber"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              userRole={userRole}
              requiredRole={['admin', 'picker', 'frozen'].includes(userRole) ? userRole : null}
              element={<Carrito />} // Cambia YourComponent por Carrito
            />
          }
        />
        <Route
          path="/paid/:ponumber/productos"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              userRole={userRole}
              requiredRole={['admin'].includes(userRole) ? userRole : null}
              element={<Productos />} // Cambia YourComponent por Carrito
            />
          }
        />
        <Route
          path="/paid/:ponumber/productos/check"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              userRole={userRole}
              requiredRole={['admin'].includes(userRole) ? userRole : null}
              element={<Completarpedido />} // Cambia YourComponent por Carrito
            />
          }
        />
        <Route
          path="/production"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              userRole={userRole}
              requiredRole={['production', 'admin', 'production_closer'].includes(userRole) ? userRole : null}
              element={<ProduccionHome />}
            />
          }
        />
        <Route
          path="/production/nueva"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              userRole={userRole}
              requiredRole={userRole === 'production' || userRole === 'admin' ? userRole : null}
              element={<ProduccionNueva />}
            />
          }
        />
        <Route
          path="/production/:po_number/editar"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              userRole={userRole}
              requiredRole={userRole === 'production' || userRole === 'admin' ? userRole : null}
              element={<ProduccionNueva />}
            />
          }
        />
        <Route
          path="/production/:po_number/retiro"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              userRole={userRole}
              requiredRole={['production', 'admin', 'frozen'].includes(userRole) ? userRole : null}
              element={<ProduccionRetiro />}
            />
          }
        />
        <Route
          path="/production/:po_number/terminar"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              userRole={userRole}
              requiredRole={userRole === 'production' || userRole === 'admin' ? userRole : null}
              element={<ProduccionTerminar />}
            />
          }
        />
        <Route
          path="/production/:po_number/cerrar"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              userRole={userRole}
              requiredRole={['admin', 'production_closer'].includes(userRole) ? userRole : null}
              element={<ProduccionCerrar />}
            />
          }
        />
        <Route
          path="/production/:po_number"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              userRole={userRole}
              requiredRole={['production', 'admin', 'production_closer'].includes(userRole) ? userRole : null}
              element={<ProduccionDetalle />}
            />
          }
        />
        <Route
          path="/cart-free"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              userRole={userRole}
              requiredRole={['admin', 'storage'].includes(userRole) ? userRole : null}
              element={<CartFreeScanner />}
            />
          }
        />
        <Route
          path="/admin/search-po"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              userRole={userRole}
              requiredRole={['admin', 'checker']}
              element={<SearchPO />}
            />
          }
        />
        <Route
          path="/admin/solicitudes"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              userRole={userRole}
              requiredRole={['admin', 'checker']}
              element={<Solicitudes />}
            />
          }
        />
        <Route
          path="/vip-preview"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              userRole={userRole}
              requiredRole="admin"
              element={<VIPPreview />}
            />
          }
        />
        <Route
          path="/admin/recepcion-stock"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              userRole={userRole}
              requiredRole="admin"
              element={<RecepcionStock />}
            />
          }
        />
        <Route
          path="/admin/contenedor"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              userRole={userRole}
              requiredRole="admin"
              element={<Contenedor />}
            />
          }
        />
        <Route
          path="/admin/test-scanner"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              userRole={userRole}
              requiredRole={['admin', 'scanner', 'picker']}
              element={<TestScanner />}
            />
          }
        />
        <Route
          path="/admin/usuarios"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              userRole={userRole}
              requiredRole="admin"
              element={<Usuarios />}
            />
          }
        />
        <Route
          path="/admin/vaciar-picking"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              userRole={userRole}
              requiredRole="admin"
              element={<VaciarPicking />}
            />
          }
        />
        <Route
          path="/editar-stock"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              userRole={userRole}
              requiredRole={['admin', 'storage']}
              element={<EditarStock />}
            />
          }
        />
      </Routes>
    </Router>
  );
};

export default App;
